// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"22":"69376dd0","203":"69376dd0","937":"3f33fdc7","994":"c65cd45b"}[chunkId] + ".css";
};